import { ReactElement } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { MobileNavigation } from './MobileNavigation'
import { WebNavigation } from './WebNavigation'

export const NavigationBar = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width: ${pageBreakpoints.md})`)

  return isMobile ? <MobileNavigation /> : <WebNavigation />
}
